export enum EDITOR_MODE {
  PREVIEW_ONLY = 'PREVIEW_ONLY',
  COLLAPSED = 'COLLAPSED',
}
